/**
 * Los productos de una cotizacion mientras se arma (COT-01): cantidad
 * editable y un boton para quitar cada uno. El precio es el de la tienda y no
 * se toca; el unico ajuste es el descuento de toda la cotizacion.
 */
import { cantidadDe } from '../../utilidades/cotizacion';
import type { LineaCotizacion } from '../../utilidades/cotizacion';
import { numero, pesos } from '../../utilidades/formato';
import { Icono } from '../comunes/Icono';
import { Imagen } from '../comunes/Imagen';
import { Tabla } from './Tabla';

export interface LineasCotizacionProps {
  lineas: LineaCotizacion[];
  onCantidad(productoId: number, cantidad: string): void;
  onQuitar(productoId: number): void;
}

export function LineasCotizacion({ lineas, onCantidad, onQuitar }: LineasCotizacionProps) {
  if (lineas.length === 0) {
    return <p className="panel-vacio">Todavía no hay productos. Búscalos arriba y agrégalos.</p>;
  }

  return (
    <Tabla
      titulo="Productos de la cotizacion"
      encabezados={
        <>
          <th scope="col">Producto</th>
          <th scope="col">Cantidad</th>
          <th scope="col" className="der">
            Valor unit. IVA inc.
          </th>
          <th scope="col" className="der">
            Total IVA inc.
          </th>
          <th scope="col">
            <span className="solo-lectores">Quitar</span>
          </th>
        </>
      }
    >
      {lineas.map((linea) => {
        const cantidad = cantidadDe(linea);
        return (
          <tr key={linea.productoId}>
            <th scope="row">
              <div className="celda-prod">
                {linea.imagen !== null ? (
                  <Imagen
                    className="mini-img"
                    src={linea.imagen.url}
                    alt=""
                    ancho={linea.imagen.ancho}
                    alto={linea.imagen.alto}
                  />
                ) : (
                  <span className="mini-img sin-foto" aria-hidden="true" />
                )}
                <span>
                  <span className="n">{linea.nombre}</span>
                  <span className="s">{linea.sku}</span>
                  {cantidad > linea.stock ? (
                    <span className="s texto-alerta">Hoy hay {numero(linea.stock)} en stock</span>
                  ) : null}
                </span>
              </div>
            </th>
            <td>
              <label className="solo-lectores" htmlFor={`cantidad-${linea.productoId}`}>
                Cantidad de {linea.nombre}
              </label>
              <input
                id={`cantidad-${linea.productoId}`}
                className="entrada entrada-cantidad"
                inputMode="numeric"
                value={linea.cantidad}
                aria-invalid={cantidad === 0}
                onChange={(evento) => {
                  onCantidad(linea.productoId, evento.target.value.replace(/\D/g, '').slice(0, 4));
                }}
              />
            </td>
            <td className="der num">{pesos(linea.precioUnitario)}</td>
            <td className="der num">{pesos(linea.precioUnitario * cantidad)}</td>
            <td className="der">
              <button
                type="button"
                className="btn btn-xs btn-contorno"
                onClick={() => {
                  onQuitar(linea.productoId);
                }}
              >
                <Icono nombre="cerrar" />
                Quitar<span className="solo-lectores"> {linea.nombre}</span>
              </button>
            </td>
          </tr>
        );
      })}
    </Tabla>
  );
}
